import { PaymentMethod } from '~/shared/constants/paymentConstants'
import { IUserStatus, IUserStatusRaw } from '~/shared/types/userTypes'

export const getUserStatusFromRawUserStatus = (
  userStatusRaw: IUserStatusRaw,
): IUserStatus => ({
  countryCode: userStatusRaw.country_code,
  isOnboardingSkipped: userStatusRaw.onboarding.is_skipped,
  onboarding: userStatusRaw.onboarding.quiz,
  config: {
    utmTags: userStatusRaw.config?.utm_tags,
    paymentMethod:
      userStatusRaw.config?.payment_method || PaymentMethod.CREDIT_CARD,
    trialPeriod: userStatusRaw.config?.trial_period || 0,
    paymentSystem: userStatusRaw.config?.payment_system || '',
    targetUuid: userStatusRaw.config?.target_uuid,
  },
  email: {
    hasEmail: userStatusRaw.email.has_email,
    onboardingEmail: userStatusRaw.email.onboarding_email,
  },
  hasSubscription: userStatusRaw.subscription.has_subscription,
  account: {
    hasAccount: userStatusRaw.account.has_account,
    email: userStatusRaw.account.identifier,
  },
  upsell: {
    isUpsellPurchased: userStatusRaw.upsell.is_upsell_purchased,
    isUpsellAvailable: userStatusRaw.upsell.is_upsell_available,
    isUpsellTried: userStatusRaw.upsell.is_upsell_tried,
  },
  upgrade: {
    isUpgradePassed: userStatusRaw.upgrade.is_upgrade_passed,
    isUpgradeAvailable: userStatusRaw.upgrade.is_upgrade_available,
  },
  savedPaymentMethod: userStatusRaw.payment_method
    ? {
        type: userStatusRaw.payment_method.type,
        card: userStatusRaw.payment_method.card
          ? {
              brand: userStatusRaw.payment_method.card.brand,
              last4: userStatusRaw.payment_method.card.last4,
              expMonth: userStatusRaw.payment_method.card.exp_month,
              expYear: userStatusRaw.payment_method.card.exp_year,
            }
          : null,
      }
    : null,
})
